import {
  AccountRepository,
  CommittedOrdersRepository,
  DistributionAreaRepository,
  DistributionLaneRepository,
  GeoCoordinateRepository,
  GridHeadersRepository,
  JobsRepository,
  LocationsRepository,
  LookupsRepository,
  MasterlocationRepository,
  MasterPlansRepository,
  PlansRepository,
  PlanTypeRepository,
  ProductPortalRepository,
  PublicLocationsRepository,
  ServicesRepository,
  TenantRepository,
  
} from '../core/repositories';
import { LocationGroupRepository } from '../core/repositories/location-group.repository';
import { MapProviderRepository } from '../core/repositories/map-provider.repository';
import { PlanRulesTemplateRepository } from '../core/repositories/plan-rules-template.repository';
import { PlanScheduledRepository } from '../core/repositories/scheduler.repository';
import { UserRulesTemplateRepository } from '../core/repositories/user-rules-template.repository';
import { VehicleGroupRepository } from '../core/repositories/vehicle-group.repository';
import { WeekdayRepository } from '../core/repositories/weekdays.repository';
import {
  CommittedOrderWebRepository,
  DistributionAreaWebRepository,
  DistributionLaneWebRepository,
  LocationWebRepository,
  LookupWebRepository,
  ServiceWebRepository,
  VehicleGroupWebRepository,
  WeekdayWebRepository,
} from './repository';
import { AccountWebRepository } from './repository/account/account-web-repository';
import { GeoCoordinatesWebRepository } from './repository/geo-coordinates/geo-coordinates-web-repository/geo-coordinates-web-repository';
import { GridHeadersWebRepository } from './repository/grid-headers/grid-headers-web-repository/grid-headers-web-repository';
import { JobWebRepository } from './repository/jobs/job-web-repository/job-web-repository';
import { LocationGroupWebRepository } from './repository/location-group/location-group-web-repository/location-group-web-repository';
import { MapProviderWebRepository } from './repository/map-providers';
import { MasterLocationWebRepository } from './repository/master-location/master-location-web-repository';
import { MasterPlanWebRepository } from './repository/master-plans/master-plan-web-repository';
import { PlanRulesTemplateWebRepository } from './repository/plan-rules-template/plan-rules-template-web-repository/plan-rules-template-web-repository';
import { PlanWebRepository } from './repository/plans/plans-web-repository';
import { ProductPortalWebRepository } from './repository/product-portal';
import { PublicLocationWebRepository } from './repository/public-locations/public-location-web-repository';
import { PlanScheduledWebRepository } from './repository/scheduler/plan-scheduled-web-repository';
import { TenantWebRepository } from './repository/tenant';
import { UserRulesTemplateWebRepository } from './repository/user-rules-template/user-rules-template.web-repository';

export function provideRepositories() {
  return [
    { provide: PlansRepository, useClass: PlanWebRepository },
    { provide: JobsRepository, useClass: JobWebRepository },
    { provide: ServicesRepository, useClass: ServiceWebRepository },
    { provide: LocationsRepository, useClass: LocationWebRepository },
    { provide: PlanTypeRepository, useClass: PlanWebRepository },
     
    { provide: GridHeadersRepository, useClass: GridHeadersWebRepository },
    { provide: LookupsRepository, useClass: LookupWebRepository },
    { provide: LocationGroupRepository, useClass: LocationGroupWebRepository },
    { provide: PublicLocationsRepository, useClass: PublicLocationWebRepository },
    {
      provide: MasterlocationRepository,
      useClass: MasterLocationWebRepository,
    },
    {
      provide: ProductPortalRepository,
      useClass: ProductPortalWebRepository,
    },
    {provide: VehicleGroupRepository, useClass: VehicleGroupWebRepository},
    { provide: GeoCoordinateRepository, useClass: GeoCoordinatesWebRepository },
    {
      provide: DistributionLaneRepository,
      useClass: DistributionLaneWebRepository,
    },
    {
      provide: DistributionAreaRepository,
      useClass: DistributionAreaWebRepository,
    },
    { provide: MasterPlansRepository, useClass: MasterPlanWebRepository },
    {
      provide: CommittedOrdersRepository,
      useClass: CommittedOrderWebRepository,
    },
    { provide: MapProviderRepository, useClass: MapProviderWebRepository },
    { provide: AccountRepository, useClass: AccountWebRepository },
    { provide: TenantRepository, useClass: TenantWebRepository },
    { provide: WeekdayRepository, useClass: WeekdayWebRepository },
    { provide: PlanScheduledRepository, useClass: PlanScheduledWebRepository },
    { provide: PlanRulesTemplateRepository, useClass: PlanRulesTemplateWebRepository },
    { provide: UserRulesTemplateRepository, useClass: UserRulesTemplateWebRepository },
  ];
}
